import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function DirectionsIcon(props) {
  return (
    <SvgIcon height="40" width="40" viewBox="0 0 25 25" {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.234 10.9138L14.0977 0.777511C13.254 -0.0662393 11.769 -0.0774893 10.914 0.777511L0.788984 10.9025C-0.0885156 11.78 -0.0885156 13.1975 0.788984 14.075L10.914 24.2C11.3527 24.6388 11.9265 24.8525 12.5002 24.8525C13.074 24.8525 13.6477 24.6388 14.0865 24.2L24.2002 14.0863C25.089 13.2313 25.1002 11.8138 24.234 10.9138ZM12.5115 22.6138L2.38648 12.4888L12.5115 2.36376L22.6365 12.4888L12.5115 22.6138ZM8.00023 11.375V15.875H10.2502V12.5H14.7502V15.3125L18.6877 11.375L14.7502 7.43751V10.25H9.12523C8.50648 10.25 8.00023 10.7563 8.00023 11.375Z"
      />
    </SvgIcon>
  );
}

export default DirectionsIcon;
